import { Flex, Text, Badge, Spacer } from '@chakra-ui/react'
import { ChangeEvent, FC, useEffect, useState } from 'react'

import useOptimizerDefault from '@hook/optimizer/use-optimizer-default'
import OptimizerConfigDefaultCreate from './ModalCreate'
import OptimizerConfigDefaultDelete from './ModalDeletr'

const SelectedTableBarDeafultOptmizer: FC = () => {
  const {
    selected,
    data,
    getData,
    setQuery,
    query: lastQuery
  } = useOptimizerDefault()

  const [query, setQueryNew] = useState(lastQuery)
  const [queryLast, setQueryNewLast] = useState(lastQuery)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    // getData(value, 0, 50, true)
    setQueryNew(value)
    setQuery(value)
  }
  useEffect(() => {
    if (query.trim() !== '' || queryLast !== '') {
      const delayDebounceFn = setTimeout(() => {
        setQueryNewLast(query)
        // Chama a API somente se o valor não estiver vazio
        getData()
      }, 2000) // Atraso de 2 segundos após a última alteração no inputValue

      return () => clearTimeout(delayDebounceFn)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
      mr={10}
    >
      {data.length > 0 && (
        <>
          <Flex alignItems="center"></Flex>
          <Flex alignItems="center">
            <Badge
              h="16px"
              minW="16.5px"
              marginRight={2}
              ml="1"
              color="#4b64c9"
              border="1px solid #4b64c9"
              background="#c0d9ff"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {selected}
            </Badge>
            <Text color={'black'}>Itens Selecionados</Text>
          </Flex>
        </>
      )}

      <Spacer />

      {selected !== 0 ? <OptimizerConfigDefaultDelete /> : []}
      <OptimizerConfigDefaultCreate />
    </Flex>
  )
}

export default SelectedTableBarDeafultOptmizer
